// extracted by mini-css-extract-plugin
module.exports = {"aboutSection":"about-module--about-section--2l3Vt","section":"about-module--section--374lt"};